import { Button, Card, Drawer, Flex, Tag, Typography } from "antd";
import dayjs from "dayjs";
import {
  capitalizeTranslated,
  formatDateTime,
  FormatDateTimeFun,
  LLFormat,
  LLFormatWithTime,
  SimpleDateFormat,
  SimpleMonthYearFormat,
  toCapitalize,
  utcDateTimeToLocalPA,
} from "../../../shared";
import { CloseOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;
const MoreDraftsDrawer = ({
  visible,
  onClose,
  selecteddraftdate,
  handleEventClick,
}) => {
  return (
    <Drawer
      title={
        <Flex justify="space-between" align="start" gap={10}>
          <Flex vertical>
            <Title level={4} className="m-0">
              {FormatDateTimeFun(selecteddraftdate?.draftDate)}
            </Title>
          </Flex>
          <Button className="border-0 p-0 bg-transparent" onClick={onClose}>
            <CloseOutlined />
          </Button>
        </Flex>
      }
      placement="right"
      width={500}
      open={visible}
      onClose={onClose}
      closeIcon={false}
      footer={null}
      zIndex={999}
    >
      <Flex vertical gap={10}>
        {selecteddraftdate?.data?.map((event, index) => (
          <Card
            size="small"
            onClick={() => handleEventClick(event)}
            style={{
              borderLeft: `4px solid ${
                event?.status === "Pending"
                  ? "#FFA500"
                  : event?.status === "Appointment scheduled"
                    ? "#52c41a"
                    : event?.status === "Callback required"
                      ? "#722ed1"
                      : event?.status === "Called"
                        ? "gold"
                        : event?.status === "No response"
                          ? "#1677ff"
                          : event?.status === "Not interested"
                            ? "#f5222d"
                            : ""
              }`,
            }}
          >
            <Flex vertical gap={2}>
              <Flex justify="space-between" gap={10}>
                <Text strong>{toCapitalize(event?.title)}</Text>
                <Tag
                  color={
                    event?.status === "Pending"
                      ? "#FFA500"
                      : event?.status === "Appointment scheduled"
                        ? "#52c41a"
                        : event?.status === "Called"
                          ? "#FFD700"
                          : event?.status === "Callback required"
                            ? "#722ed1"
                            : event?.status === "No response"
                              ? "#1677ff "
                              : event?.status === "Not interested"
                                ? "#f5222d "
                                : ""
                  }
                  className="radius-12"
                >
                  {capitalizeTranslated(event?.status)}
                </Tag>
              </Flex>
              <Flex gap={10}>
                <Text>
                  {utcDateTimeToLocalPA(event?.alldata?.when_to_call_again)}
                </Text>
              </Flex>
              <Flex justify="end" wrap gap={4}>
                <Tag className="m-0">
                  {event?.alldata?.services?.map((list) =>
                    toCapitalize(list?.name),
                  )}
                </Tag>
              </Flex>
            </Flex>
          </Card>
        ))}
      </Flex>
    </Drawer>
  );
};

export { MoreDraftsDrawer };
